// extracted by mini-css-extract-plugin
module.exports = {"checkboxText":"deleteActionDialog_checkboxText__29-JM","cautionText":"deleteActionDialog_cautionText__3By1R"};